// extracted by mini-css-extract-plugin
module.exports = {"segment":"Segment--segment--25ls6"};